export const THIRD_PARTY_CUSTOM_APP_TYPE = 'third_party_custom'

/** `ApplicationRepository.type` of a CRM instance — the only app that emits outbound webhooks. */
export const CRM_APP_TYPE = 'crm'
